module.exports = __webpack_public_path__ + "static/media/map-marker-tom.363ab6fc.png";